<template>
  <div
    v-show="state"
    class="dialog_wrapper"
    ref="main_id"
    style="z-index: 2003;"
  >
    <button type="button" class="dialog__headerbtn" @click="close">
      <i class="iconfont iconquxiao1"></i>
    </button>
    <div class="font_p">长按图片保存到手机</div>
    <div class="font_bg">
      <div class="bg_text">
        点击右上角更多
        <br />分享给好友或朋友圈
      </div>
      <div class="bg_Pointer"></div>
    </div>
  </div>
</template>

<script>
import { getList } from "@/api/map_api";
export default {
  name: "DialogPosters",
  props: ["state"],
  data() {
    return {
      num: 0,
      mydata: "",
      myTime: "",
      arr: ["../../static/images/popup_to.jpg", "../../static/images/popup.png"]
    };
  },
  created() {
    this.getNowTime();
  },
  mounted() {
    this.$nextTick(() => {
      this.getData();
      // this.dialog();
    });
  },
  methods: {
    close() {
      this.$emit("transfer", this.state);
    },
    getData() {
      let _this = this;
      getList().then(res => {
        for (let index = 0; index < res.data.length; index++) {
          _this.num = _this.num + parseInt(res.data[index].num);
        }
        // console.log(_this.num)
        this.dialog();
      });
    },
    getNowTime() {
      // 加0
      function add_10(num) {
        if (num < 10) {
          num = "0" + num;
        }
        return num;
      }
      var myDate = new Date();
      myDate.getYear(); //获取当前年份(2位)
      myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      myDate.getMonth(); //获取当前月份(0-11,0代表1月)
      myDate.getDate(); //获取当前日(1-31)
      myDate.getDay(); //获取当前星期X(0-6,0代表星期天)
      myDate.getTime(); //获取当前时间(从1970.1.1开始的毫秒数)
      myDate.getHours(); //获取当前小时数(0-23)
      myDate.getMinutes(); //获取当前分钟数(0-59)
      myDate.getSeconds(); //获取当前秒数(0-59)
      myDate.getMilliseconds(); //获取当前毫秒数(0-999)
      myDate.toLocaleDateString(); //获取当前日期
      this.mydata =
        myDate.getFullYear() +
        "-" +
        add_10(myDate.getMonth() + 1) +
        "-" +
        myDate.getDate() +
        " " +
        add_10(myDate.getHours()) +
        ":" +
        add_10(myDate.getMinutes()) +
        ":" +
        add_10(myDate.getSeconds());
      this.myTime =
        myDate.getFullYear() +
        "-" +
        add_10(myDate.getMonth() + 1) +
        "-" +
        myDate.getDate();
    },
    dialog() {
      // console.log(this.num)
      let _this = this;
      let canvas = document.createElement("canvas");
      canvas.width = 589;
      canvas.height = 921;
      canvas.style = ``;
      if (!canvas.getContext) return;
      let ctx = canvas.getContext("2d"); //创建Image对象
      var img = new Image();
      img.onload = function() {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        _this.fillRoundRect(ctx, 100, 328, canvas.width/1.5, 30, 10, 'rgba(0,0,0,0.8)');
        ctx.font = "18px small-caps";
        ctx.fillStyle = "#ffffff";
        ctx.fillText(
          "截至" + _this.myTime + "中央指导组组织278支国家医疗队共32395人",
          55,
          180
        );
        ctx.font = " normal bold 40px fontFamily";
        ctx.fillStyle = "red";
        ctx.fillText("全国", 100, 270);
        ctx.font = " normal normal 22px fontFamily";
        ctx.fillStyle = "#000000";
        ctx.fillText(
          "全网已统计援鄂医疗队名单共计" + _this.num + "人",
          100,
          315
        );
        ctx.font = " normal normal 18px fontFamily";
        ctx.fillStyle = "#ffffff";
        ctx.textAlign="center";
        ctx.fillText("截至" + _this.mydata + "全网数据收集统计", 298, 350);
        ctx.font = " normal normal 22px fontFamily";
        ctx.fillStyle = "#ffffff";
        ctx.textAlign="center";
        ctx.fillText("扫码查看最新名单", 300, 860);
      };
      img.src = this.arr[Math.floor(Math.random() * 2)];
      setTimeout(() => {
        //新Image对象，可以理解为DOM
        var image = new Image();
        // canvas.toDataURL 返回的是一串Base64编码的URL
        // 指定格式 PNG
        image.src = canvas.toDataURL("image/png");
        image.style = `
            display: block;    
            height: 535px;
            margin: 0 auto 50px;
            margin-top: 10vh;
            border-radius: 5px;`;
        this.$refs.main_id.appendChild(image);
      }, 1000);
    },
    fillRoundRect(cxt, x, y, width, height, radius, /*optional*/ fillColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false;
      }

      cxt.save();
      cxt.translate(x, y);
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius);
      cxt.fillStyle = fillColor || "#000"; //若是给定了值就用给定的值否则给予默认值
      cxt.fill();
      cxt.restore();
    },
    drawRoundRectPath(cxt, width, height, radius) {
        cxt.beginPath(0);
        //从右下角顺时针绘制，弧度从0到1/2PI  
        cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);

        //矩形下边线  
        cxt.lineTo(radius, height);

        //左下角圆弧，弧度从1/2PI到PI  
        cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);

        //矩形左边线  
        cxt.lineTo(0, radius);

        //左上角圆弧，弧度从PI到3/2PI  
        cxt.arc(radius, radius, radius, Math.PI, Math.PI * 3 / 2);

        //上边线  
        cxt.lineTo(width - radius, 0);

        //右上角圆弧  
        cxt.arc(width - radius, radius, radius, Math.PI * 3 / 2, Math.PI * 2);

        //右边线  
        cxt.lineTo(width, height - radius);
        cxt.closePath();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.dialog_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.5);
  .dialog__headerbtn {
    width: 30px;
    height: 30px;
    padding: 0;
    position: absolute;
    left: calc(100% - 18vw);
    top: 11vh;
    background: #fff;
    border-radius: 50%;
    border: none;
    outline: none;
    cursor: pointer;

    i {
      font-size: 10px;
      color: #2949ed;
    }
  }
  .font_p {
    position: absolute;
    right: calc(50% - 70px);
    top: calc(10vh + 550px);
    font-size: 15px;
    color: #ffffff;
    letter-spacing: 1px;
  }
  .font_bg {
    position: absolute;
    right: 30px;
    top: 0;
    width: 220px;
    height: 60px;
    display: flex;
    .bg_text {
      width: 65%;
      height: 60px;
      color: #ffffff;
      font-size: 15px;
      display: inline-flex;
      align-items: flex-end;
    }
    .bg_Pointer {
      width: 35%;
      height: 38px;
      background: url("../../static/images/Pointer.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialogPosters.vue